/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApartmentTypeDto,
  CustomerSelectionDto,
  FinishSelectionModel,
  InfoDto,
  OperationResult,
  ProjectDto,
} from '../models';
import {
    ApartmentTypeDtoFromJSON,
    ApartmentTypeDtoToJSON,
    CustomerSelectionDtoFromJSON,
    CustomerSelectionDtoToJSON,
    FinishSelectionModelFromJSON,
    FinishSelectionModelToJSON,
    InfoDtoFromJSON,
    InfoDtoToJSON,
    OperationResultFromJSON,
    OperationResultToJSON,
    ProjectDtoFromJSON,
    ProjectDtoToJSON,
} from '../models';

export interface AdminApiProjectsProjectIdExportGetRequest {
    projectId: number;
}

export interface ApiPublicProjectIdCustomerCustomerIdGetRequest {
    projectId: number;
    customerId: number;
}

export interface ApiPublicProjectIdCustomerCustomerIdSelectionsFinishPostRequest {
    projectId: number;
    customerId: number;
    finishSelectionModel: FinishSelectionModel;
}

export interface ApiPublicProjectIdCustomerCustomerIdSelectionsGetRequest {
    projectId: number;
    customerId: number;
}

export interface ApiPublicProjectIdCustomerCustomerIdSelectionsRoomRoomIdPostRequest {
    projectId: number;
    customerId: number;
    roomId: number;
    customerSelectionDto: CustomerSelectionDto;
}

export interface ApiPublicProjectIdCustomerCustomerIdSelectionsStartPostRequest {
    projectId: number;
    customerId: number;
}

export interface ApiPublicProjectIdGetRequest {
    projectId: number;
}

export interface ApiPublicProjectIdProductProductIdInfoGetRequest {
    projectId: number;
    productId: number;
}

export interface ProjectsProjectIdGetRequest {
    projectId: number;
}

/**
 * 
 */
export class AddOnSelectorBackendApi extends runtime.BaseAPI {

    /**
     */
    async adminApiProjectsProjectIdExportGetRaw(requestParameters: AdminApiProjectsProjectIdExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling adminApiProjectsProjectIdExportGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/api/projects/{projectId}/export`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async adminApiProjectsProjectIdExportGet(requestParameters: AdminApiProjectsProjectIdExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminApiProjectsProjectIdExportGetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPublicProjectIdCustomerCustomerIdGetRaw(requestParameters: ApiPublicProjectIdCustomerCustomerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApartmentTypeDto>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiPublicProjectIdCustomerCustomerIdGet.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling apiPublicProjectIdCustomerCustomerIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/public/{projectId}/customer/{customerId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApartmentTypeDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiPublicProjectIdCustomerCustomerIdGet(requestParameters: ApiPublicProjectIdCustomerCustomerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApartmentTypeDto> {
        const response = await this.apiPublicProjectIdCustomerCustomerIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPublicProjectIdCustomerCustomerIdSelectionsFinishPostRaw(requestParameters: ApiPublicProjectIdCustomerCustomerIdSelectionsFinishPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResult>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiPublicProjectIdCustomerCustomerIdSelectionsFinishPost.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling apiPublicProjectIdCustomerCustomerIdSelectionsFinishPost.');
        }

        if (requestParameters.finishSelectionModel === null || requestParameters.finishSelectionModel === undefined) {
            throw new runtime.RequiredError('finishSelectionModel','Required parameter requestParameters.finishSelectionModel was null or undefined when calling apiPublicProjectIdCustomerCustomerIdSelectionsFinishPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/public/{projectId}/customer/{customerId}/selections/finish`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FinishSelectionModelToJSON(requestParameters.finishSelectionModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResultFromJSON(jsonValue));
    }

    /**
     */
    async apiPublicProjectIdCustomerCustomerIdSelectionsFinishPost(requestParameters: ApiPublicProjectIdCustomerCustomerIdSelectionsFinishPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResult> {
        const response = await this.apiPublicProjectIdCustomerCustomerIdSelectionsFinishPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPublicProjectIdCustomerCustomerIdSelectionsGetRaw(requestParameters: ApiPublicProjectIdCustomerCustomerIdSelectionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerSelectionDto>>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiPublicProjectIdCustomerCustomerIdSelectionsGet.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling apiPublicProjectIdCustomerCustomerIdSelectionsGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/public/{projectId}/customer/{customerId}/selections`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerSelectionDtoFromJSON));
    }

    /**
     */
    async apiPublicProjectIdCustomerCustomerIdSelectionsGet(requestParameters: ApiPublicProjectIdCustomerCustomerIdSelectionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerSelectionDto>> {
        const response = await this.apiPublicProjectIdCustomerCustomerIdSelectionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPublicProjectIdCustomerCustomerIdSelectionsRoomRoomIdPostRaw(requestParameters: ApiPublicProjectIdCustomerCustomerIdSelectionsRoomRoomIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResult>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiPublicProjectIdCustomerCustomerIdSelectionsRoomRoomIdPost.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling apiPublicProjectIdCustomerCustomerIdSelectionsRoomRoomIdPost.');
        }

        if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
            throw new runtime.RequiredError('roomId','Required parameter requestParameters.roomId was null or undefined when calling apiPublicProjectIdCustomerCustomerIdSelectionsRoomRoomIdPost.');
        }

        if (requestParameters.customerSelectionDto === null || requestParameters.customerSelectionDto === undefined) {
            throw new runtime.RequiredError('customerSelectionDto','Required parameter requestParameters.customerSelectionDto was null or undefined when calling apiPublicProjectIdCustomerCustomerIdSelectionsRoomRoomIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/public/{projectId}/customer/{customerId}/selections/room/{roomId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))).replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerSelectionDtoToJSON(requestParameters.customerSelectionDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResultFromJSON(jsonValue));
    }

    /**
     */
    async apiPublicProjectIdCustomerCustomerIdSelectionsRoomRoomIdPost(requestParameters: ApiPublicProjectIdCustomerCustomerIdSelectionsRoomRoomIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResult> {
        const response = await this.apiPublicProjectIdCustomerCustomerIdSelectionsRoomRoomIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPublicProjectIdCustomerCustomerIdSelectionsStartPostRaw(requestParameters: ApiPublicProjectIdCustomerCustomerIdSelectionsStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerSelectionDto>>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiPublicProjectIdCustomerCustomerIdSelectionsStartPost.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling apiPublicProjectIdCustomerCustomerIdSelectionsStartPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/public/{projectId}/customer/{customerId}/selections/start`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerSelectionDtoFromJSON));
    }

    /**
     */
    async apiPublicProjectIdCustomerCustomerIdSelectionsStartPost(requestParameters: ApiPublicProjectIdCustomerCustomerIdSelectionsStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerSelectionDto>> {
        const response = await this.apiPublicProjectIdCustomerCustomerIdSelectionsStartPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPublicProjectIdGetRaw(requestParameters: ApiPublicProjectIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectDto>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiPublicProjectIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/public/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiPublicProjectIdGet(requestParameters: ApiPublicProjectIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectDto> {
        const response = await this.apiPublicProjectIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPublicProjectIdProductProductIdInfoGetRaw(requestParameters: ApiPublicProjectIdProductProductIdInfoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InfoDto>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiPublicProjectIdProductProductIdInfoGet.');
        }

        if (requestParameters.productId === null || requestParameters.productId === undefined) {
            throw new runtime.RequiredError('productId','Required parameter requestParameters.productId was null or undefined when calling apiPublicProjectIdProductProductIdInfoGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/public/{projectId}/product/{productId}/info`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters.productId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiPublicProjectIdProductProductIdInfoGet(requestParameters: ApiPublicProjectIdProductProductIdInfoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InfoDto> {
        const response = await this.apiPublicProjectIdProductProductIdInfoGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async projectsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProjectDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectDtoFromJSON));
    }

    /**
     */
    async projectsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProjectDto>> {
        const response = await this.projectsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async projectsProjectIdGetRaw(requestParameters: ProjectsProjectIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectDto>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling projectsProjectIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDtoFromJSON(jsonValue));
    }

    /**
     */
    async projectsProjectIdGet(requestParameters: ProjectsProjectIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectDto> {
        const response = await this.projectsProjectIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
